exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.country-row .fa-arrow-right[data-v-110963a9] {\n\tdisplay: none;\n}\n.country-row:hover .fa-arrow-right[data-v-110963a9] {\n\tdisplay: inline;\n}\n.country-row td[data-v-110963a9]:nth-child(1) {\n\twhite-space: nowrap;\n}\n", ""]);

// exports
